import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useJobs } from '../../contexts/JobContext';
import { Button } from '../ui/Button';

export const ResumePrompt: React.FC = () => {
  const { jobs } = useJobs();
  const navigate = useNavigate();
  const [visible, setVisible] = React.useState(false);

  const active = React.useMemo(()=> jobs.filter(j => j.status !== 'completed' && j.status !== 'failed').sort((a,b)=>(b.updated_at||0)-(a.updated_at||0))[0], [jobs]);

  React.useEffect(()=>{
    if (!active) { setVisible(false); return; }
    const dismissed = sessionStorage.getItem('resume_prompt_dismissed');
    if (!dismissed) setVisible(true);
  },[active]);

  if (!visible || !active) return null;

  const onResume = () => {
    setVisible(false);
    sessionStorage.setItem('resume_prompt_dismissed','1');
    if (active.resume_url) navigate(active.resume_url);
    else if (active.anchors?.candidate_id && active.anchors?.requirement_id) navigate(`/candidates/${active.anchors.candidate_id}/analysis/${active.anchors.requirement_id}`);
    else if (active.anchors?.candidate_id) navigate(`/candidates/${active.anchors.candidate_id}`);
  };

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-40 bg-white dark:bg-gray-800 backdrop-blur-xl border border-gray-200 dark:border-gray-600 rounded-xl px-5 py-3.5 shadow-lg dark:shadow-gray-900/50 flex items-center gap-4">
      <div className="text-sm font-medium text-gray-700 dark:text-gray-200">
        Pick up where you left off?
      </div>
      <Button 
        size="sm" 
        onClick={onResume} 
        className="bg-gradient-to-r from-indigo-500 to-purple-600 hover:from-indigo-600 hover:to-purple-700 text-white font-medium px-4 py-1.5 rounded-lg shadow-sm"
      >
        Resume
      </Button>
      <Button 
        size="sm" 
        variant="ghost" 
        onClick={()=>{ setVisible(false); sessionStorage.setItem('resume_prompt_dismissed','1'); }}
        className="text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white hover:bg-gray-100 dark:hover:bg-gray-700 font-medium px-3 py-1.5 rounded-lg"
      >
        Dismiss
      </Button>
    </div>
  );
};

export default ResumePrompt;


